let animations = {
    init: () => {
        // identify svg element
        function identifyElement(selector) {
            TweenMax.to(selector, 5, {
                rotation: 360,
                transformOrigin: "left 66%",
                ease: Linear.easeNone,
                repeat: -1
            });
        }

        identifyElement(".theGroup");
    }
};

$(document).ready(animations.init);
